module.exports = __webpack_public_path__ + "static/media/Samantha.e2dc30f1.png";